export default "__VITE_ASSET__DnfC0Jq1__"